import React from "react";
import googlePlay from "../../../../assets/images/google_play.svg";
import appStore from "../../../../assets/images/app_store.svg";
import mobile from "../../../../assets/images/iPhone_16_Plus.png";
import overlayCircle from "../../../../assets/images/Overlay.png";

const DownloadSection = () => {
  return (
<section id="download" className="download-section d-flex align-items-center">
  <div className="container">
    <div className="row align-items-center justify-content-center">
      {/* Text Section */}
      <div className="col-12 col-lg-6 text-center text-lg-start mb-5 mb-lg-0">
        <h2 className="fs-48 mb-4 mb-md-5">
          Our IOS & Android <br className="d-none d-md-block" />
          application are ready!
        </h2>
        <p className="fs-5 text-muted mb-4">
          Download DOXBOX and start in under 2 minutes!
        </p>
        <p className="fs-5 text-muted">Is it free? Yes, absolutely free.</p>
        <div className="d-flex justify-content-center justify-content-lg-start align-items-center gap-3 mt-4">
          <img src={appStore} alt="App Store" className="store-img" />
          <img src={googlePlay} alt="Google Play" className="store-img" />
        </div>
      </div>

      {/* Image Section */}
      <div className="col-12 col-lg-6 position-relative text-center">
        <img src={overlayCircle} alt="Overlay" className="overlay-bg img-fluid" />
        <img
          src={mobile}
          alt="Mobile Preview"
          className="mobile-img img-fluid position-absolute"
        />
      </div>
    </div>
  </div>
</section>
  );
};

export default DownloadSection;
